// ===============================
// pages/Home.jsx
// FULLY DYNAMIC HOME PAGE
// ===============================

import React, {
  useContext,
  useEffect,
  useState,
} from "react";

import {
  Link,
} from "react-router-dom";

import axios from "axios";

import {
  CartContext,
} from "../../context/CartContext";

import "./Home.css";

const Home = () => {

  // ===============================
  // CONTEXT
  // ===============================

  const {
    addToCart,
  } = useContext(CartContext);

  // ===============================
  // STATES
  // ===============================

  const [products, setProducts] =
    useState([]);

  const [categories, setCategories] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  // ===============================
  // FETCH PRODUCTS
  // ===============================

  useEffect(() => {

    fetchProducts();

  }, []);

  const fetchProducts = async () => {

    try {

      const res = await axios.get(
        "http://localhost:5000/api/products"
      );

      const allProducts =
        res.data;

      // FEATURED PRODUCTS

      setProducts(
        allProducts.slice(0, 8)
      );

      // DYNAMIC CATEGORIES

      const uniqueCategories = [

        ...new Set(

          allProducts.map(
            (item) => item.category
          )

        ),

      ];

      // CATEGORY IMAGES

      const categoryData =
        uniqueCategories.map(
          (cat, index) => ({

            id: index + 1,

            name: cat,

            image:
              allProducts.find(
                (item) =>
                  item.category === cat
              )?.image,

          })
        );

      setCategories(categoryData);

      setLoading(false);

    } catch (error) {

      console.log(error);

      setLoading(false);

    }

  };

  return (
    <div className="home-page">

      {/* ===============================
          HERO SECTION
      =============================== */}

      <section className="hero-section">

        <div className="container hero-content">

          {/* LEFT */}

          <div className="hero-text">

            <span>
              Trending Collection 2026
            </span>

            <h1>
              Discover Premium Products
              For Modern Lifestyle
            </h1>

            <p>
              Explore thousands of premium
              products with fast delivery,
              secure payments and amazing
              offers.
            </p>

            <Link to="/shop">

              <button>
                Shop Now
              </button>

            </Link>

          </div>

          {/* RIGHT */}

          <div className="hero-image">

            <img
              src="https://images.unsplash.com/photo-1523381210434-271e8be1f52b"
              alt="hero"
            />

          </div>

        </div>

      </section>

      {/* ===============================
          CATEGORIES
      =============================== */}

      <section className="categories-section">

        <div className="container">

          <div className="section-title">

            <h2>
              Shop By Categories
            </h2>

            <p>
              Explore trending collections
            </p>

          </div>

          {loading ? (

            <div className="loading-box">

              <h2>
                Loading Categories...
              </h2>

            </div>

          ) : (

            <div className="categories-grid">

              {categories.map((item) => (

                <Link
  to={`/shop?category=${item.name}`}
  className="category-card"
  key={item.id}
>

                  <img
                    src={item.image}
                    alt={item.name}
                  />

                  <div className="category-overlay">

                    <h3>
                      {item.name}
                    </h3>

                  </div>

                </Link>

              ))}

            </div>

          )}

        </div>

      </section>

      {/* ===============================
          FEATURED PRODUCTS
      =============================== */}

      <section className="products-section">

        <div className="container">

          <div className="section-title">

            <h2>
              Featured Products
            </h2>

            <p>
              Best selling products
            </p>

          </div>

          {loading ? (

            <div className="loading-box">

              <h2>
                Loading Products...
              </h2>

            </div>

          ) : (

            <div className="products-grid">

              {products.map((product) => (

                <div
                  className="product-card"
                  key={product._id}
                >

                  {/* PRODUCT LINK */}

                  <Link
                    to={`/product/${product._id}`}
                    className="product-link"
                  >

                    <div className="product-image">

                      <img
                        src={product.image}
                        alt={product.name}
                      />

                    </div>

                    <div className="product-info">

                      <span className="home-category">

                        {product.category}

                      </span>

                      <h3>
                        {product.name}
                      </h3>

                      <p className="home-price">

                        ₹{product.price}

                      </p>

                      <p className="home-description">

                        {
                          product.description
                        }
                      </p>

                    </div>

                  </Link>

                  {/* BUTTON */}

                  <div className="home-btn-area">

                    <button
                      onClick={() =>
                        addToCart({
                          ...product,
                          quantity: 1,
                        })
                      }
                    >
                      Add To Cart
                    </button>

                  </div>

                </div>

              ))}

            </div>

          )}

          {/* VIEW ALL */}

          <div className="view-all-btn">

            <Link to="/shop">

              <button>
                View All Products
              </button>

            </Link>

          </div>

        </div>

      </section>

      {/* ===============================
          OFFER BANNER
      =============================== */}

      <section className="offer-banner">

        <div className="container offer-content">

          <div>

            <h2>
              Big Sale Up To 50% OFF
            </h2>

            <p>
              Grab your favorite products
              today with exclusive deals.
            </p>

          </div>

          <Link to="/deals">

            <button>
              Explore Deals
            </button>

          </Link>

        </div>

      </section>

    </div>
  );
};

export default Home;